module.exports = __webpack_public_path__ + "media/images/landing/persons/pavel-trnka-9f4a34bd153acdbb5288a500a2406945.jpg";